<div id="menu-options" [(style.top)]="positionY" [(style.left)]="positionX">
    <ul id="menu-ul">
        <li class="right-click-menu-item" (click)="copySelectionToAll()" (mouseenter)="showAllCells(true)" (mouseout)="showAllCells(false)">Copy selection to all</li>
        <li class="right-click-menu-item" (click)="copySelectionToVacant()" (mouseenter)="showVacantCells(true)" (mouseout)="showVacantCells(false)">Copy selection to vacant cells</li>
    </ul>
</div>